import { render, staticRenderFns } from "./EndUseSortSettings.vue?vue&type=template&id=22476b85&"
import script from "./EndUseSortSettings.vue?vue&type=script&lang=js&"
export * from "./EndUseSortSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports